const headerSearch = {
  openClass: 'header-search--open',

  toggleSearchForm(btn) {

    if(this.searchForm) {
      const currentlyOpen = this.searchForm.classList.contains(this.openClass);

      if(currentlyOpen) {
        // Close
        btn.setAttribute('aria-expanded', 'false');
        this.searchForm.classList.remove(this.openClass);
        // Set focus back to opener button
        btn.focus();
      } else {
        // Open
        btn.setAttribute('aria-expanded', 'true');
        this.searchForm.classList.add(this.openClass);
        // Set focus to first input
        const firstFocusable = this.searchForm.querySelectorAll('select, input, button, textarea')[0];
        if(firstFocusable) {
          firstFocusable.focus();
        }
      }

    }
  },

  init() {
    this.searchForm = document.querySelector('.header-search');
    document.querySelectorAll('.js--toggle-header-search').forEach(btn => {
      btn.addEventListener('click', event => {
        this.toggleSearchForm(btn);
      });
    });
  }
};

export default headerSearch;
